import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
import { CONTACT, SOCIAL } from '../lib/siteConfig';
import { TikTokIcon } from './BrandIcons';

const LOGO_URL = "/logo-white.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <img
              src={LOGO_URL}
              alt="La Finca - Jardín y Villa"
              className="h-24 w-auto p-2 rounded-lg"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Un espacio privado rodeado de naturaleza, creado para desconectarte, disfrutar y vivir momentos especiales.
            </p>
            <div className="flex space-x-4">
              <a
                href={SOCIAL.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                aria-label="Síguenos en Instagram"
                className="text-gray-400 hover:text-[#C8962D] transition-colors"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a
                href={SOCIAL.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                aria-label="Síguenos en Facebook"
                className="text-gray-400 hover:text-[#C8962D] transition-colors"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a
                href={SOCIAL.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-tiktok"
                aria-label="Síguenos en TikTok"
                className="text-gray-400 hover:text-[#C8962D] transition-colors"
              >
                <TikTokIcon className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-lg mb-4 text-[#C8962D]">Enlaces</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/villa" className="text-gray-400 hover:text-white transition-colors">
                  Villa de Descanso
                </Link>
              </li>
              <li>
                <Link to="/jardin" className="text-gray-400 hover:text-white transition-colors">
                  Jardín de Eventos
                </Link>
              </li>
              <li>
                <Link to="/reservar" className="text-gray-400 hover:text-white transition-colors">
                  Reservar
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-serif text-lg mb-4 text-[#C8962D]">Servicios</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Hospedaje </li>
              <li>Day Pass</li>
              <li>Bodas</li>
              <li>XV años</li>
              <li>Bautizos</li>
              <li>Cumpleaños</li>
              <li>Eventos Corporativos</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-serif text-lg mb-4 text-[#C8962D]">Contacto</h3>
            <ul className="space-y-4 text-gray-400">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#C8962D] flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  {CONTACT.addressLine1}, {CONTACT.addressLine2}
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-[#C8962D] flex-shrink-0" />
                <a href={CONTACT.phoneHref} className="text-sm hover:text-white transition-colors">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-[#C8962D] flex-shrink-0" />
                <a href={CONTACT.emailHref} className="text-sm hover:text-white transition-colors">
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} La Finca - Jardín y Villa. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacidad" className="text-gray-500 hover:text-white text-sm transition-colors">
              Privacidad
            </Link>
            <Link to="/terminos" className="text-gray-500 hover:text-white text-sm transition-colors">
              Términos
            </Link>
          </div>
        </div>
      </div>

      {/* Novagente Widget */}
      {/*<script src="https://api.novagente.io/widget.js"></script>*/}
    </footer>
  );
}
